import React, { useState } from 'react';
import { Typography } from 'antd';
import OrderListTemplate from './components/OrderListTemplate';
import { useDefaultQueryFields } from './order.effect';
import { OrderTriggerActionProvider } from './components/OrderTriggerActionMap';
import { generateOrderUrl } from './components/effect';
import { MergedOrder, OrderTabScene } from '../../types/process/order';

const { Link } = Typography;

const OrderRenewalList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const tabScene = OrderTabScene.GroupRenewal;
  const queryFields = useDefaultQueryFields(tabScene);

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={tabScene}
        defaultScene='tab_renewal_all'
        queryFields={queryFields}
        viewModes={[
          { 
            mode: 'list', 
            label: '列表',
            renderInfo: (order: MergedOrder) => {
              const originNo = order.orderData?.renewalOriginOrderNo;
              if (!originNo) return null;
              
              return (
                <Link 
                  href={generateOrderUrl({ orderNo: originNo, targetScene: 'tab_all', targetPath: '/order/list' })} 
                  target="_blank"
                >
                  原订单: {originNo}
                </Link>
              );
            }
          }
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderRenewalList;
